import { tenantSelector } from '@/features/configuration/configurationSelector';
import type { TransKeys } from '@/i18n/trans/index';
import { createTrans } from '@/i18n/trans/index';
import { useSelector } from '@/store/utils';
import { ExternalLink } from '@fleet/webshop-ui';
import type { FC } from 'react';
import { Trans } from 'react-i18next';

const TenantCopies = createTrans({
  'turnit.successMessage': (
    <Trans i18nKey="tenant.turnit.successMessage" defaults="Success!" />
  ),
  'turnit.travelPassDisclaimer': <></>,
  'turnit.ticketSent': (
    <Trans
      i18nKey="tenant.turnit.ticketSent"
      defaults="Your tickets have been sent to your email address."
    />
  ),
  'velvet.successMessage': (
    <Trans i18nKey="tenant.velvet.successMessage" defaults="Success!" />
  ),
  'velvet.travelPassDisclaimer': <></>,
  'velvet.ticketSent': (
    <Trans
      i18nKey="tenant.velvet.ticketSent"
      defaults="Your tickets have been sent to your email address."
    />
  ),
  'aguia.successMessage': (
    <Trans i18nKey="tenant.aguia.successMessage" defaults="Success!" />
  ),
  'aguia.travelPassDisclaimer': <></>,
  'aguia.ticketSent': (
    <Trans
      i18nKey="tenant.veaguiavet.ticketSent"
      defaults="Your tickets have been sent to your email address."
    />
  ),
  'arenaways.successMessage': (
    <Trans
      i18nKey="tenant.arenaways.successMessage"
      defaults="Let this journey begin, Arenaways style!"
    />
  ),
  'arenaways.travelPassDisclaimer': (
    <Trans
      i18nKey="tenant.arenaways.travelPassDisclaimer"
      defaults="<0>Click here</0> for integrated TRAIN+BUS travel passes"
      components={[
        <a
          href="https://www.autobus.it/arenaways-to/TPLWebPortal/it/showcase"
          target="_blank"
        />,
      ]}
    />
  ),
  'arenaways.ticketSent': (
    <Trans
      i18nKey="tenant.arenaways.ticketSent"
      defaults="Your tickets have been sent to your email address."
    />
  ),
  'twiliner.successMessage': (
    <Trans
      i18nKey="tenant.twiliner.successMessage"
      defaults="Your booking was successful! We look forward to welcoming you on board soon.<br /> <br />If you have any questions until then, please check our <faqLink>FAQ</faqLink> or contact our <mailToLink>customer support</mailToLink>."
      components={{
        faqLink: (
          <ExternalLink
            href="http://www.twiliner.com/faq"
            variant="body1-link"
          />
        ),
        mailToLink: (
          <ExternalLink
            href="mailto:service@twiliner.com"
            variant="body1-link"
          />
        ),
      }}
    />
  ),
  'twiliner.travelPassDisclaimer': <></>,
  'twiliner.ticketSent': (
    <Trans
      i18nKey="tenant.twiliner.ticketSent"
      defaults="Your tickets have been sent to your email address. If you haven't received anything or can't find it in your spam folder, <mailToLink>please send us a message</mailToLink>."
      components={{
        mailToLink: (
          <ExternalLink
            href="mailto:service@twiliner.com"
            variant="body1-link"
          />
        ),
      }}
    />
  ),
  'sandbox-fs.successMessage': (
    <Trans i18nKey="tenant.fs.successMessage" defaults="Success!" />
  ),
  'sandbox-fs.travelPassDisclaimer': <></>,
  'sandbox-fs.ticketSent': (
    <Trans
      i18nKey="tenant.fs.ticketSent"
      defaults="Your tickets have been sent to your email address."
    />
  ),
  'tifrance.successMessage': (
    <Trans i18nKey="tenant.fs.successMessage" defaults="Success!" />
  ),
  'tifrance.travelPassDisclaimer': <></>,
  'tifrance.ticketSent': (
    <Trans
      i18nKey="tenant.fs.ticketSent"
      defaults="Your tickets have been sent to your email address."
    />
  ),
  'maas.successMessage': (
    <Trans i18nKey="tenant.maas.successMessage" defaults="Success!" />
  ),
  'maas.travelPassDisclaimer': <></>,
  'maas.ticketSent': (
    <Trans
      i18nKey="tenant.maas.ticketSent"
      defaults="Your tickets have been sent to your email address."
    />
  ),
  'hellenictrain.successMessage': (
    <Trans i18nKey="tenant.hellenictrain.successMessage" defaults="Success!" />
  ),
  'hellenictrain.travelPassDisclaimer': <></>,
  'hellenictrain.ticketSent': (
    <Trans
      i18nKey="tenant.hellenictrain.ticketSent"
      defaults="Your tickets have been sent to your email address."
    />
  ),
});

export const TransTenantSpecific: FC<{ i18nKey: TransTenantSpecificKeys }> = ({
  i18nKey,
}) => {
  const { value: tenant } = useSelector(tenantSelector);

  return <TenantCopies i18nKey={`${tenant}.${i18nKey}`} />;
};

type TenantCopiesKeys = TransKeys<typeof TenantCopies>;
type TransKeySuffix<S> = S extends `${string}.${infer Suffix}` ? Suffix : never;

export type TransTenantSpecificKeys = TransKeySuffix<TenantCopiesKeys>;
